export const openLink = "https://report.1japp.com"; //报告网址
export const guidanceLink = "https://guide.1japp.com"; //引导页网址
